import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Cookies() {
  return (
    <PageLayout
      title="Cookie Policy"
      subtitle="How Paygent uses cookies and similar technologies."
      badge="LEGAL"
    >
      <div className="prose prose-lg max-w-4xl mx-auto text-gray-600">
        <p className="text-sm text-gray-400 mb-8">Last updated: April 23, 2026</p>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What Are Cookies?</h2>
          <p>Cookies are small text files stored on your device when you visit a website. They help us recognize your browser, remember preferences, and understand how you interact with our platform.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies We Use</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse mt-4">
              <thead>
                <tr className="bg-gray-50">
                  <th className="text-left p-3 font-bold text-gray-900 border-b-2 border-gray-200">Category</th>
                  <th className="text-left p-3 font-bold text-gray-900 border-b-2 border-gray-200">Purpose</th>
                  <th className="text-left p-3 font-bold text-gray-900 border-b-2 border-gray-200">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="p-3 font-semibold text-gray-800">Essential</td>
                  <td className="p-3">Authentication, security, and core platform functionality. These cannot be disabled.</td>
                  <td className="p-3">Session</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="p-3 font-semibold text-gray-800">Functional</td>
                  <td className="p-3">Remember your preferences, language settings, and dashboard configurations.</td>
                  <td className="p-3">1 year</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="p-3 font-semibold text-gray-800">Analytics</td>
                  <td className="p-3">Understand how visitors use our site to improve the experience. Data is aggregated and anonymized.</td>
                  <td className="p-3">2 years</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="p-3 font-semibold text-gray-800">AI Concierge</td>
                  <td className="p-3">Our AI concierge (Tarry) uses localStorage to maintain conversation continuity across visits.</td>
                  <td className="p-3">Persistent</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Managing Cookies</h2>
          <p>You can control cookies through your browser settings. Most browsers allow you to block or delete cookies. However, blocking essential cookies may prevent you from using certain features of the Paygent platform.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
          <p>For questions about our cookie practices, contact <a href="mailto:privacy@gopaygent.com" className="text-blue-600 hover:underline">privacy@gopaygent.com</a>.</p>
        </section>
      </div>
    </PageLayout>
  );
}
